import { Loader2 } from 'lucide-react';

/** `fullScreen` for the pre-shell states (auth, company lookup); inline otherwise. */
export function PortalLoading({ label = 'Loading…', fullScreen = false }: { label?: string; fullScreen?: boolean }) {
  const inner = (
    <div className="flex flex-col items-center gap-3 py-12 text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm">{label}</p>
    </div>
  );
  if (!fullScreen) return inner;
  return <div className="min-h-screen bg-muted flex items-center justify-center p-4">{inner}</div>;
}
